class DiyEverythingGallery {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-gallery-track]');
    this.slides = Array.from(root.querySelectorAll('[data-gallery-slide]'));
    this.thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    this.prev = root.querySelector('[data-gallery-prev]');
    this.next = root.querySelector('[data-gallery-next]');
    this.currentIndex = Math.max(0, Math.min(this.parseInitialIndex(), Math.max(0, this.slides.length - 1)));

    if (!this.track || this.slides.length === 0) return;

    this.bindEvents();
    this.update();
  }

  parseInitialIndex() {
    const raw = parseInt(this.root?.dataset?.initialIndex || '0', 10);
    if (!Number.isFinite(raw)) return 0;
    if (raw < 0) return 0;
    return raw;
  }

  bindEvents() {
    if (this.prev) {
      this.prev.addEventListener('click', (event) => {
        event.preventDefault();
        this.go(-1);
      });
    }

    if (this.next) {
      this.next.addEventListener('click', (event) => {
        event.preventDefault();
        this.go(1);
      });
    }

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        const index = parseInt(thumb.dataset.index || '0', 10);
        if (!Number.isFinite(index)) return;
        this.setIndex(index);
      });
    });
  }

  go(delta) {
    this.setIndex(this.currentIndex + delta);
  }

  setIndex(index) {
    const maxIndex = Math.max(0, this.slides.length - 1);
    const next = Math.max(0, Math.min(index, maxIndex));
    if (next === this.currentIndex) {
      this.updateNavState();
      return;
    }
    this.currentIndex = next;
    this.update();
  }

  update() {
    const x = this.currentIndex * 100;
    this.track.style.transform = `translateX(-${x}%)`;

    this.thumbs.forEach((thumb, index) => {
      const active = index === this.currentIndex;
      thumb.classList.toggle('is-active', active);
      if (active) {
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    });

    this.updateNavState();
  }

  updateNavState() {
    const maxIndex = Math.max(0, this.slides.length - 1);
    if (this.currentIndex > maxIndex) this.currentIndex = maxIndex;
    if (this.prev) this.prev.disabled = this.currentIndex <= 0;
    if (this.next) this.next.disabled = this.currentIndex >= maxIndex;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-diy-everything-gallery]').forEach((root) => {
    new DiyEverythingGallery(root);
  });
});
